import { render, staticRenderFns } from "./MarriageWsHeader.vue?vue&type=template&id=ca6a0a06&scoped=true&"
import script from "./MarriageWsHeader.vue?vue&type=script&lang=js&"
export * from "./MarriageWsHeader.vue?vue&type=script&lang=js&"
import style0 from "./MarriageWsHeader.vue?vue&type=style&index=0&id=ca6a0a06&scoped=true&lang=css&"
import style1 from "./MarriageWsHeader.vue?vue&type=style&index=1&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ca6a0a06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
